import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';
import {environment} from '../environments/environment';

import 'es6-promise';
import 'isomorphic-fetch';

export function fetchTranslations(){
  const api = environment.config.server.sahara + '/api/translation/dictionary';
  return () => fetch(api, {
  }).then(parseResponse);
}
function parseResponse(res: any) {
  return res.json().then((resp) => {
    window['translations'] = resp.data;
  });
}

@NgModule({
    imports: [
        HttpModule,
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        BrowserAnimationsModule,

    ],
    declarations: [
        AppComponent
    ],
    providers: [{
      'provide': APP_INITIALIZER,
      'useFactory': fetchTranslations,
      'deps': [],
      'multi': true,
    }],
    bootstrap: [AppComponent]
})

export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts